import React from 'react';
import Modal from 'react-bootstrap/Modal'
import {useSelector, useDispatch} from "react-redux";
import { setDeleteClientId, deleteClient} from "../../actions/client";

const ClientDeleteForm = () => {

    const dispatch = useDispatch();

    const {delete_client, currentPage, numberOfPages, clients} = useSelector(state => state.client);

    const closeModal = () =>{
        // removing client user from redux state by sending null setDeleteClientId
        dispatch(setDeleteClientId(null))
    };

    let getPage = null;

    const onConfirm = () =>{

        if ((currentPage === numberOfPages) && (clients.length === 1) ){
            getPage = (currentPage - 1);
        }
        else{
            getPage = currentPage;
        }
        dispatch(deleteClient(delete_client.id, getPage))
    };

    let condition = false;
    if(delete_client !== null)
        condition = true;

    return (
        <div>
            <Modal show={condition} onHide={closeModal}>
                <Modal.Header className="bg-danger" closeButton>
                    <Modal.Title className="text-white" >Mijozni o'chirish</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Siz haqiqatdan ham ushbu mijozni o'chirmoqchimisiz ?
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={closeModal} className="btn btn-secondary">YO'Q</button>
                    <button onClick={onConfirm} className="btn btn-primary">HA</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ClientDeleteForm;